import { render, staticRenderFns } from "./agent-chat.vue?vue&type=template&id=321bb376&scoped=true"
import script from "./agent-chat.vue?vue&type=script&lang=js"
export * from "./agent-chat.vue?vue&type=script&lang=js"
import style0 from "./agent-chat.vue?vue&type=style&index=0&id=321bb376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321bb376",
  null
  
)

export default component.exports